import { useUser } from "hooks/firestore/simple/useUser"
import { useCurrentUser } from "hooks/localstate/auth/useCurrentUser"
import { ReactNode, useCallback, useEffect, useState } from "react"
import Intercom from "react-intercom"
import { localIntercomAppId } from "util-functions/init"
import { functions } from "../firebase/firebase"

const IntercomProvider = ({ children }: { children: ReactNode }) => {
  const userDoc = useUser()
  const auth = useCurrentUser()

  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState<
    { user_id: string; email: string; company_id: string; company: { id: string }; user_hash: string } | undefined
  >(undefined)

  const setUserData = useCallback(async () => {
    const hashFunction = functions.httpsCallable("groupA-createUserHMAC")
    if (auth?.uid && userDoc) {
      try {
        const result = await hashFunction()
        setUser({
          user_id: auth.uid,
          email: auth.email ?? "",
          company_id: userDoc.getpackedAdmin ? "" : userDoc.currentRestaurant || "",
          company: {
            id: userDoc.getpackedAdmin ? "" : userDoc.currentRestaurant || "",
          },
          user_hash: result.data,
        })
        setLoading(false)
      } catch (error) {
        console.log("error")
        setLoading(false)
      }
    } else {
      setUser(undefined)
      setLoading(false)
    }
  }, [auth?.uid, userDoc?.currentRestaurant, auth?.email])

  useEffect(() => {
    setUserData()
  }, [auth?.uid, userDoc?.currentRestaurant, auth?.email])

  return (
    <>
      {children}
      {user?.user_id && !loading && <Intercom appID={localIntercomAppId} {...user} />}
    </>
  )
}

export default IntercomProvider
